import { bffServiceInstanceManage } from "@/plugins/api_service/services";

const prefix = "/management/upload-progressing";

export default {
  uploadFile: (body) =>
    bffServiceInstanceManage.post(`${prefix}/upload`, {}, body),
};
